import React from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogFooter } from '../../../../components/ui/dialog';
import { Button } from '../../../../components/ui/button';
import { Input } from '../../../../components/ui/input';
import { Label } from '../../../../components/ui/label';

export const AllocateStatementRowDialog = ({
  allocateDialog,
  setAllocateDialog,
  loansList,
  loansSearch,
  setLoansSearch,
  handleAllocate,
}) => (
  <Dialog open={allocateDialog.open} onOpenChange={o => { setAllocateDialog(p => ({...p, open: o})); if (!o) { setLoansSearch(''); } }}>
    <DialogContent className="max-w-sm">
      <DialogHeader><DialogTitle>Allocate Transaction</DialogTitle><DialogDescription>Link this transaction to a specific loan</DialogDescription></DialogHeader>
      <div className="py-4 space-y-3">
        <div className="space-y-2">
          <Label>Search Loan</Label>
          <Input
            placeholder="Search by loan ID or client..."
            value={loansSearch}
            onChange={e => setLoansSearch(e.target.value)}
            data-testid="allocate-loan-search"
          />
        </div>
        {loansList.length > 0 ? (
          <div className="max-h-48 overflow-y-auto border rounded-md divide-y">
            {loansList.map(loan => (
              <div
                key={loan.id}
                className={`px-3 py-2 cursor-pointer text-sm hover:bg-amber-50 ${allocateDialog.loanId === loan.id ? 'bg-amber-100 font-medium' : ''}`}
                onClick={() => setAllocateDialog(p => ({...p, loanId: loan.id}))}
                data-testid={`loan-option-${loan.id}`}
              >
                <span className="font-mono text-blue-700">{loan.id}</span>
                <span className="text-gray-500 ml-2 text-xs">{loan.label.split('—')[1]?.trim()}</span>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-sm text-gray-400 text-center py-2">
            {loansSearch ? 'No loans found' : 'Type to search loans'}
          </div>
        )}
        <div className="space-y-1">
          <Label className="text-xs text-gray-500">Or enter manually</Label>
          <Input
            placeholder="Enter loan ID directly (e.g. LOAN001)"
            value={allocateDialog.loanId}
            onChange={e => setAllocateDialog(p => ({...p, loanId: e.target.value}))}
            data-testid="allocate-loan-id"
          />
        </div>
      </div>
      <DialogFooter>
        <Button variant="outline" onClick={() => { setAllocateDialog({open:false,txn:null,loanId:''}); setLoansSearch(''); }}>Cancel</Button>
        <Button onClick={handleAllocate} disabled={!allocateDialog.loanId} className="bg-amber-500 hover:bg-amber-600 text-slate-900">Allocate</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
